export const apiHostName = document.location.hostname;
export const apiHost = `http://${apiHostName}:8000`;
export const commonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};
